import React from "react";

export default function Login() {
    return(
        <p>
            Login
        </p>
    )
}